<template>
    <v-select
        v-model="selected"
        multiple
        class="bg-white"
        label="title"
        :placeholder="placeholder"
        :options="options"
        :append-to-body="true"
        @input="onChange"
    />
</template>

<script>
import vSelect from 'vue-select'
import axios from '@axios'
import Cache from "@core/api/request/Cache";

export default {
    components: {
        vSelect
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        placeholder: {
            default() {
                return this.$t('Component(Grid):column-select-value')
            }
        },
        initialValue: {
            default() {
                return []
            }
        },
        cache: {
            default: false
        },
        cacheId: {
            default: null
        },
        ttl: {
            default: 300
        },
        optionsNormalizer: {
            default() {
                return (o) => o;
            }
        }
    },
    data() {
        return {
            selected: [],
            options: [],
            timer: null,
        };
    },
    methods: {
        clear() {
            this.selected.splice(0);
        },
        onChange() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.$emit('search', this.selected);
            }, 600);
        },
        handleResponse(data) {
            this.options = this.optionsNormalizer(data);

            this.options.forEach(o => {
                if (this.initialValue.includes(o.id)) {
                    this.selected.push(o);
                }
            });
        },
    },
    mounted() {
        let promise = null;
        if (this.cache && this.cacheId) {
            promise = Cache.item(this.cacheId, () => {
                return axios.get(this.url);
            }).getPromise();
        } else {
            promise = axios.get(this.url);
        }
        promise.then((r) => this.handleResponse(r.data));
    }
}
</script>

<style scoped>

</style>
